import { Component } from 'react'
import { Flex, Box } from 'theme-ui'

import { Link } from 'react-router'
import Logomark from '../framework/Logomark'

class Header extends Component {
  render() {
    return (
      <Box
        sx={{
          backgroundColor: 'primaryDark',
          width: '100%'
        }}>
        <Flex
          sx={{
            margin: `0 auto`,
            maxWidth: '80em',
            width: '100%',
            paddingTop: '1rem',
            paddingBottom: '1rem',
            paddingLeft: ['1rem', '1.5rem', '2rem'],
            paddingRight: ['1rem', '1.5rem', '2rem'],
            justifyContent: 'space-between',
            alignItems: 'center'
          }}>
          <Box sx={{ zIndex: 1000 }}>
            <Link
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 2,
                color: 'white',
                textDecoration: 'none',
                fontWeight: 'bold',
                '&:hover': { color: 'primary', borderBottom: 'none' }
              }}
              to="/home2">
              <Logomark style={{ position: 'relative', top: 1 }} fill={'#03A9F4'} size={22} />
              <Box sx={{ color: 'white', fontSize: 2 }}>Polis</Box>
            </Link>
          </Box>
          <Box>
            <Link
              sx={{
                color: 'white',
                textDecoration: 'none',
                fontWeight: 'bold',
                fontSize: 2,
                px: 3,
                py: 2,
                borderRadius: 'default',
                backgroundColor: 'primary',
                '&:hover': { backgroundColor: 'infoHover', borderBottom: 'none', color: 'white' }
              }}
              to="/signin">
              Увійти
            </Link>
          </Box>
        </Flex>
      </Box>
    )
  }
}

export default Header
